import React, { useEffect, useState } from "react";
import styles from '../styles.module.scss';
import Button from "../../../../../../../components/Buttons/Button";
import Dropdown from "../../../../../../../components/Inputs/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { selectOrganisationSites } from "../../../../../../../redux/selectors/organisation";
import TextInput from "../../../../../../../components/Inputs/TextInput";
import FlexColumn from "../../../../../../../components/FlexBox/FlexColumn";
import Typography from "../../../../../../../components/Typography/Typography";
import { colors } from "../../../../../../../styles/colors";
import { doGetSpintlySerialNumber } from "../../../../../../../redux/thunks/controllers";
import SButton from "../../../../../../../components/SButton/SButton";
import FlexRow from "../../../../../../../components/FlexBox/FlexRow";
import { FormControlLabel, Radio, RadioGroup, withStyles } from "@material-ui/core";

const StyledRadio = withStyles({
    root: {
        color: '#BDC7D9',
        '&$checked': {
            color: '#03BFFF',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

const SiteDetails = ({ hNext, hBack, hSave, accessPointDetails, inProgress = false }) => {

    const dispatch = useDispatch();
    console.log({ accessPointDetails })

    const { sites } = useSelector((state) => ({
        sites: selectOrganisationSites(state),
    }));

    const [site, setSite] = useState({ name: '', value: '' });
    const [network, setNetwork] = useState({ id: 0, name: '', extServicesState: '' });
    const [disabled, setDisabled] = useState(true);

    const [controllerDeviceSerialNum, setControllerDeviceSerialNum] = useState({
        value: '',
        description: '',
        error: '',
        vendorSerialNumber: '',
        vendorToSpintlySerialNum: ''
    });

    const [noOfControllerChannels, setNoOfControllerChannels] = useState(accessPointDetails?.controllerType === '1' ? 1 : 4);
    const [wireProtocol, setWireProtocol] = useState("2")

    const selectedSite = site?.value ? sites.find((siteValue) => siteValue.id === site?.value) : [];
    const currentNetworks = selectedSite?.networks?.length > 0 ? selectedSite.networks : [];

    useEffect(() => {
        if (accessPointDetails?.site) {
            setSite(accessPointDetails?.site)
        }
        if (accessPointDetails?.network) {
            setNetwork(accessPointDetails?.network)
        }

        if (accessPointDetails?.controllerDeviceSerialNum?.value) {
            setControllerDeviceSerialNum({
                value: accessPointDetails?.controllerDeviceSerialNum?.value,
                description: accessPointDetails?.controllerDeviceSerialNum?.description,
                error: accessPointDetails?.controllerDeviceSerialNum?.error,
                vendorSerialNumber: accessPointDetails?.controllerDeviceSerialNum?.vendorSerialNumber,
                vendorToSpintlySerialNum: accessPointDetails?.controllerDeviceSerialNum?.vendorToSpintlySerialNum
            })
        }

        if (accessPointDetails?.wireProtocol) {
            setWireProtocol(accessPointDetails?.wireProtocol)
        }

        if (accessPointDetails?.noOfControllerChannels) {
            setNoOfControllerChannels(accessPointDetails?.noOfControllerChannels)
        }

    }, [accessPointDetails])

    useEffect(() => {
        if (!site?.value || !network?.id || ((accessPointDetails?.withController && ['2', '5']?.includes(accessPointDetails?.controllerType)) && (!noOfControllerChannels || !controllerDeviceSerialNum?.value || controllerDeviceSerialNum?.error))) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    }, [site, network, controllerDeviceSerialNum]);


    const handleNext = () => {
        if (['2']?.includes(accessPointDetails?.controllerType) &&
            (controllerDeviceSerialNum?.value !== controllerDeviceSerialNum?.vendorSerialNumber)
        ) {
            dispatch(doGetSpintlySerialNumber(controllerDeviceSerialNum?.value, (data) => {
                setControllerDeviceSerialNum(prev => ({
                    ...prev,
                    vendorSerialNumber: controllerDeviceSerialNum?.value,
                    vendorToSpintlySerialNum: data?.message?.serialNumber
                }));

                const toSend = {
                    site,
                    network,
                    noOfControllerChannels,
                    controllerDeviceSerialNum: {
                        ...controllerDeviceSerialNum,
                        vendorSerialNumber: controllerDeviceSerialNum?.value,
                        vendorToSpintlySerialNum: data?.message?.serialNumber
                    },
                    wireProtocol,
                }

                hNext && hNext(toSend, 2);

            }))
        } else {
            const toSend = {
                site,
                network
            }

            if (accessPointDetails?.withController && accessPointDetails?.controllerType !== '4') {
                toSend["noOfControllerChannels"] = noOfControllerChannels;
                toSend["controllerDeviceSerialNum"] = controllerDeviceSerialNum;
                toSend["wireProtocol"] = wireProtocol;
            }

            if (accessPointDetails?.withController && accessPointDetails?.controllerType === "5") {
                hSave && hSave(toSend);
            } else {
                hNext && hNext(toSend, 2);
            }
        }
    }

    const handleSerialDescription = (value, field) => {
        const switchCase = value.substring(0, 4);
        let description = '';
        switch (String(switchCase)) {
            case '1001':
            case '1002':
            case '1016':
            case '101F':
            case '1021':
            case '1026':
            case '1032':
            case '1028':
            case '1029':
            case '1033':
            case '1034':
            case '103B':
            case '103A':
                description = 'Mobile/Card';
                break;
            case '1023':
            case '1015':
                description = 'Mobile/Card/Fingerprint';
                break;
            case '1024':
            case '1025':
            case '103D':
            case '102F':
                description = 'Face/Card';
                break;
            case '1027':
                description = 'Mobile';
                break;
            case '1038':
                description = 'Mobile/QR/Card';
                break;
            default:
                break;
        }

        let error = '';

        // if (!['1039', '1040', '103C']?.includes(value?.substring(0, 4))) {
        //     error = "Serial number doesn't support the configuration";
        // } else if (value.length !== 14) {
        //     error = 'Please enter a valid Serial Number'
        // }

        if (field === 'controller') {
            const isIstar = accessPointDetails?.withController && accessPointDetails?.controllerType === '5';
            if (isIstar && value?.substring(0, 4) !== '1041') {
                error = "Serial number doesn't support the configuration"
            } else if (isIstar && value.length !== 14) {
                error = 'Please enter a valid Serial Number'
            } else {
                error = ''
            }
            setControllerDeviceSerialNum({ description: description, value: value?.trim(), error: error });
        }
        if (switchCase === '1044') {
            setNoOfControllerChannels(8);
            setWireProtocol("3");
        } else if (accessPointDetails?.controllerType === '1' && noOfControllerChannels === 8) {
            setNoOfControllerChannels(1);
        }
    };

    return (<>
        <FlexColumn alignItems="start" styles={{ marginBottom: '4rem' }}>
            <Dropdown
                placeholder="Site"
                value={site?.name}
                onChange={(data) => {
                    setSite({
                        ...data,
                        name: data.name,
                        value: data.id,
                    });
                    setNetwork({ name: '', value: '' });
                }}
                data={sites}

            />
            <Dropdown
                placeholder="Network"
                value={network.name}
                disabled={site.value === ''}
                onChange={(data) => {
                    setNetwork({ ...data });
                }}
                data={currentNetworks}
            />

            {(accessPointDetails?.withController && accessPointDetails?.controllerType !== '4') &&
                <>
                    <TextInput
                        name=""
                        maxLength={14}
                        description={controllerDeviceSerialNum?.description}
                        placeholder={['2', '5']?.includes(accessPointDetails?.controllerType) ? `${accessPointDetails?.controllerType === "2" ? "Azure" : "iStar"}  Controller Serial Number` : "Controller Device Serial Number"}
                        value={controllerDeviceSerialNum?.value}
                        error={controllerDeviceSerialNum?.error}
                        onChange={(e) => handleSerialDescription(e.target.value, 'controller')}
                    />
                    {['2']?.includes(accessPointDetails?.controllerType) && <Typography variant={"b3R"} color={colors.info700}>Enter the serial number present on the Azure controller</Typography>}
                    <Dropdown
                        placeholder="No of channels"
                        value={noOfControllerChannels}
                        onChange={(data) => {
                            setNoOfControllerChannels(data)
                        }}
                        data={(accessPointDetails?.controllerType === '1' && controllerDeviceSerialNum?.value?.slice(0, 4) === '1044') ? [8] : accessPointDetails?.controllerType === '1' ? [1] : accessPointDetails?.controllerType === '5' ? [4] : [2, 4]}
                    />
                    <FlexColumn alignItems="start" styles={{ marginTop: '1rem' }}>
                        <Typography variant={"b1SB"} color={colors?.info700}>Communication Protocol</Typography>
                        <RadioGroup style={{ display: 'flex', flexDirection: 'row', gap: '2rem' }} aria-label="Communication-Protocol" name="communicationProtocol" value={wireProtocol} onChange={(e) => {
                            const value = e.target.value;
                            setWireProtocol(value);
                        }}>
                            {(accessPointDetails?.controllerType === '1' && controllerDeviceSerialNum?.value?.slice(0, 4) === '1044') ? <></> : <FormControlLabel value="2" control={<StyledRadio />} label="Weigand" />}
                            <FormControlLabel value="3" control={<StyledRadio />} label={'OSDP'} />
                        </RadioGroup>
                    </FlexColumn>
                </>
            }
        </FlexColumn>

        <FlexRow styles={{ marginTop: '1rem' }} justifyContent="end" className={styles["fixed-actions"]}>
            <SButton color={"grey"} disabled={inProgress} minWidth onClick={() => { hBack && hBack(0) }}>Back</SButton>
            <SButton disabled={inProgress || disabled} minWidth onClick={handleNext}>{accessPointDetails?.withController && accessPointDetails?.controllerType === "5" ? "Save" : "Next"}</SButton>
        </FlexRow>
    </>)
};

export default SiteDetails;